// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ReForm from "../../reform/ReForm.bs.jsx";
import * as Styles from "../../styles/components/Styles.bs.jsx";
import * as LogUtils from "../../utils/LogUtils.bs.jsx";
import * as Validators from "../../utils/Validators.bs.jsx";
import * as HtmlEntities from "../../utils/HtmlEntities.bs.jsx";
import * as InputWrapper from "../../components/InputWrapper/InputWrapper.bs.jsx";
import * as Stdlib_JsExn from "@rescript/runtime/lib/es6/Stdlib_JsExn.js";
import * as FirebaseError from "../../backend/FirebaseError.bs.jsx";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Stdlib_Promise from "@rescript/runtime/lib/es6/Stdlib_Promise.js";
import * as ReForm__Helpers from "../../reform/ReForm__Helpers.bs.jsx";
import * as JsxRuntime from "react/jsx-runtime";
import * as UnauthenticatedTemplate from "./UnauthenticatedTemplate.bs.jsx";

function get(state, field) {
  switch (field) {
    case "Email" :
      return state.email;
    case "Password" :
      return state.password;
    case "PasswordConfirmation" :
      return state.passwordConfirmation;
  }
}

function set(state, field, value) {
  switch (field) {
    case "Email" :
      return {
        email: value,
        password: state.password,
        passwordConfirmation: state.passwordConfirmation
      };
    case "Password" :
      return {
        email: state.email,
        password: value,
        passwordConfirmation: state.passwordConfirmation
      };
    case "PasswordConfirmation" :
      return {
        email: state.email,
        password: state.password,
        passwordConfirmation: value
      };
  }
}

let FormFields = {
  get: get,
  set: set
};

let Form = ReForm.Make({
  set: set,
  get: get
});

let Validators$1 = Validators.CustomValidators({
  set: set,
  get: get
});

function SignUpForm(props) {
  let onGoBack = props.onGoBack;
  let onSubmit = props.onSubmit;
  let form = Form.use({
    email: "",
    password: "",
    passwordConfirmation: ""
  }, Validators$1.schema([
    Validators$1.required("Email"),
    Validators$1.email("Email"),
    Validators$1.required("Password"),
    Validators$1.password("Password"),
    Validators$1.matchField("Password", "Hesla se neshodují", "PasswordConfirmation")
  ]), param => {
    let raiseSubmitFailed = param.raiseSubmitFailed;
    let match = param.state.values;
    Stdlib_Promise.$$catch(onSubmit({
      email: match.email,
      password: match.password
    }), error => {
      let match = FirebaseError.toFirebaseError(error);
      let errorMessage;
      if (match.RE_EXN_ID === FirebaseError.EmailExists) {
        errorMessage = `Tento e` + HtmlEntities.nbhp + `mail už je zaregistrovaný.`;
      } else {
        let exn = Stdlib_Option.getOrThrow(Stdlib_JsExn.fromException(error), undefined);
        LogUtils.captureException(exn);
        let msg = Stdlib_JsExn.message(exn);
        errorMessage = msg !== undefined ? `Chyba: ` + msg : "Neznámá chyba";
      }
      raiseSubmitFailed(errorMessage);
      return Promise.resolve();
    });
  }, undefined, undefined, "OnDemand", undefined);
  let maybeErrorMessage = form.state.formState;
  let tmp;
  if (typeof maybeErrorMessage !== "object") {
    tmp = null;
  } else {
    let maybeErrorMessage$1 = maybeErrorMessage._0;
    tmp = maybeErrorMessage$1 !== undefined ? maybeErrorMessage$1 : "Neznámá chyba";
  }
  return <UnauthenticatedTemplate.make
    isOnline={props.isOnline}
  >
    <h2>
      {"Registrace"}
    </h2>
    <Form.Provider.make
      value={form}
    >
      <form
        className={Styles.stack.base}
        onSubmit={ReForm__Helpers.handleSubmit(form.submit)}
      >
        <fieldset
          className={`reset ` + Styles.fieldset.grid}
        >
          <Form.Field.make
            field={"Email"}
            render={field => <InputWrapper.make
              inputError={field.error}
              inputName={"email"}
              inputSlot={<input
                autoComplete={"username email"}
                type={"email"}
                value={field.value}
                onChange={ReForm__Helpers.handleChange(field.handleChange)}
              />}
              labelSlot={`E` + HtmlEntities.nbhp + `mail`}
            />}
          />
          <Form.Field.make
            field={"Password"}
            render={field => <InputWrapper.make
              inputError={field.error}
              inputName={"password"}
              inputSlot={<input
                autoComplete={"new-password"}
                type={"password"}
                value={field.value}
                onChange={ReForm__Helpers.handleChange(field.handleChange)}
              />}
              labelSlot={`Heslo`}
            />}
          />
          <Form.Field.make
            field={"PasswordConfirmation"}
            render={field => <InputWrapper.make
              inputError={field.error}
              inputName={"passwordConfirmation"}
              inputSlot={<input
                autoComplete={"new-password"}
                type={"password"}
                value={field.value}
                onChange={ReForm__Helpers.handleChange(field.handleChange)}
              />}
              labelSlot={`Heslo znovu`}
            />}
          />
        </fieldset>
        {tmp}
        <button
          className={Styles.button.base}
          type={"submit"}
        >
          {`Zaregistrovat se`}
        </button>
      </form>
    </Form.Provider.make>
    <p>
      {`Jste tu omylem? `}
      <button
        className={Styles.link.base}
        type={"button"}
        onClick={param => onGoBack()}
      >
        {`Zpět na přihlášení.`}
      </button>
    </p>
  </UnauthenticatedTemplate.make>;
}

let make = SignUpForm;

export {
  FormFields,
  Form,
  Validators$1 as Validators,
  make,
}
/* Form Not a pure module */
